import { render, staticRenderFns } from "./ReleasesCostsEditPanel.vue?vue&type=template&id=48753fc6"
import script from "./ReleasesCostsEditPanel.vue?vue&type=script&lang=js"
export * from "./ReleasesCostsEditPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports